import React from 'react';
import LazyLoad from 'react-lazyload';
import { withError } from '../../shared/components/error-boundary';
import ImageWithPlaceholder from '../../shared/components/image-with-placeholder';
import StaticContent from '../../ui/components/static-content';
import SEOParagraph from './seo-paragraph';
import ShoppingLinks from './shopping-links';
import DisclaimerList from './disclaimer-list';
import AccessibleElement from '../../ui/components/accessible-element';
import withWindowResize from '../../ui/components/window-resize';

import '../css/disclaimer-v2.less';

class DisclaimerV2 extends React.PureComponent {
	static whyDidYouRender = true;

	constructor() {
		super();
		this.state = {
			showDisclaimer: false,
			showContact: false,
		}

		this.showChatWindow = this.showChatWindow.bind(this);
		this.showPhoneWindow = this.showPhoneWindow.bind(this);
	}

	showChatWindow() {
		/*let url = "https://h30665.www3.hp.com/netagent/cimlogin.aspx?questid=246C34C5-5B3F-42D0-9EEC-D51634B0EE3F&portid=942E5E82-25F9-4DFD-9A71-537876996383&nareferer=" + encodeURIComponent(document.location.href);
		window.open(url, '_blank', 'resizable= yes,width=625,height=750,scrollbars=yes');*/
		if (!!window.startMoxieEngagement) {
			window.startMoxieEngagement('Live Chat Help')
		}
	}

	showPhoneWindow() {
		let url = "https://store.hp.com/static/live_help_call_not_available.html";
		window.open(url, '_blank', 'resizable= yes,width=625,height=750,scrollbars=yes');
	}

	handleToggleDisclaimer = () => {
		this.setState({ showDisclaimer: !this.state.showDisclaimer })
	}

	render() {
		const { device } = this.props;
		return (
			<React.Fragment>
				{(!this.props.hideSeoParagraph && this.props.seoParagraph && device === 'desktop') &&
					<SEOParagraph seoParagraph={this.props.seoParagraph} className={'v2'}
					/>}
				<div className="shoppinglinks_support v2">
					<ShoppingLinks />
					<section className="lp_chat">
						<LazyLoad height={91} once={true} offset={400}>
							<ImageWithPlaceholder className='image-content' src="//www.hp.com/us-en/shop/app/assets/images/uploads/prod/lpchat-square1606770930108674.png" />
						</LazyLoad>
						<h2>Need help?</h2>
						<a className="live_help_dd downDisclosure arrow-down"
							href=""
							onClick={(e) => {
								e.preventDefault();
								this.setState({ showContact: !this.state.showContact });
							}}>Contact us now</a>
						<ul className={"live_help_list" + (this.state.showContact ? " show" : "")}
							onMouseLeave={() => this.setState({ showContact: false })}>
							<AccessibleElement
								element="li"
								onClick={this.showChatWindow}
							>
								<a className="lp_link">Chat with a sales rep</a>
							</AccessibleElement>
							<li><a href={`${process.env.BASENAME}/SendEmailView?catalogId=10051&langId=-1&storeId=10151`} tabIndex={0}>Send us an email</a></li>
						</ul>
					</section>
				</div>
				<div className="disclaimer v2">
					<div className={"disclaimer-section" + (this.state.showDisclaimer ? " show" : "")}>
						{(!this.props.hideSeoParagraph && this.props.seoParagraph && device === 'mobile') &&
							<SEOParagraph seoParagraph={this.props.seoParagraph} className={'v2'}
							/>}
						<div className="disclaimerWrapper">
							<div className={"disclaimer-header"}>
								<AccessibleElement
									element="span"
									onClick={this.handleToggleDisclaimer}
								>
									Disclaimer
								</AccessibleElement>
							</div>
							<StaticContent>
								<DisclaimerList />
							</StaticContent>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

export default withError(withWindowResize(DisclaimerV2));
